import React, { memo, useEffect, useMemo, useCallback, useState, useRef } from "react"
import moment from "moment-timezone"
import ReactAudioPlayer from "react-audio-player"

//REDUX
import { connect, useSelector } from "react-redux"
import { bindActionCreators } from "redux"
import * as reduxActions from "store/actions"
import reduxStore from "store/"

//COMPONENTS
import Card from "components/Card"
import CardTags from "components/Tags/Card"
import CustomButton from "components/Buttons/custom"
import HeaderWithIcon from "components/Header/card"
import Icon from "components/Icon"
import IconButton from "components/CustomButtons/IconButton"
import ReplyMessage from "./message"
import MoreVert from "components/MoreMenu/"
import SelectUsers from "components/User/select"
import TextField from "components/TextField"
import UserBadge from "components/Badge/user"

//@MATERIAL
import Avatar from "@material-ui/core/Avatar"
import AvatarGroup from "@material-ui/lab/AvatarGroup"
import Dialog from "@material-ui/core/Dialog"
import Tooltip from "@material-ui/core/Tooltip"
import { makeStyles } from "@material-ui/core/styles"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"

//STYLES
import styles from "assets/jss/material-dashboard-pro-react/components/timelineStyle";

//FUNCTIONS
import {
    translate,
    formatNumber,
    customApp,
    Highlighted,
    links,
    appAlert
} from "functions/"

import {
    interact,
    deleteMessage,
    forwardMessage,
    mentionedUsers
} from "functions/chat"

//IMAGES
import defaultAvatar from "assets/img/fundo-sonne.png"
import SVGIcon from "assets/icons/svg.png"

// Componente otimizado para reações
const ReactionButtons = memo(({
    overOptions,
    reaction,
    reactThis,
    storie,
    session,
    setForward,
    props,
    closeOptionsHandle,
    overOptionsHandle,
    cancelConfirm,
    translate,
    customApp
}) => {
    const canDelete = useMemo(() => (
        !storie.deleted &&
        storie.type === 'comment' &&
        storie.user &&
        storie.user._id &&
        storie.user._id === session._id &&
        parseInt(storie.created_at) > parseInt(moment().unix('x')) - 360
    ), [storie, session]);

    const reactionButtonStyle = useMemo(() => ({
        display: "flex",
        minWidth: "fit-content",
        justifyContent: "center",
        padding: "4px 2px", // Mais espaço para facilitar o hover
        margin: "-4px 0", // Compensa o padding para manter o layout
        borderRadius: "4px", // Borda arredondada para melhorar a estética
    }), []);

    // Função para manter as opções abertas quando está sobre os botões
    const handleMouseEnter = useCallback(() => {
        if (overOptionsHandle) {
            overOptionsHandle(true);
        }
    }, [overOptionsHandle]);

    // Função para fechar com timeout maior para permitir movimento entre botões
    const handleMouseLeave = useCallback(() => {
        if (closeOptionsHandle) {
            closeOptionsHandle(1500); // Aumentando o timeout para 1500ms
        }
    }, [closeOptionsHandle]);
    // Array de configurações de botões de reação para simplificar o código
    const reactionIcons = useMemo(() => [
        {
            type: "like",
            icon: reaction === "like" ? "thumb_up" : "thumb_up_off_alt",
            title: translate("$__like", 1),
            color: reaction === "like" ? customApp("menu") : customApp("medium"),
        },
        {
            type: "nolike",
            icon: reaction === "nolike" ? "thumb_down" : "thumb_down_off_alt",
            title: translate("$__notlike", 1),
            color: reaction === "nolike" ? customApp("menu") : customApp("medium"),
        },
        {
            type: "love",
            icon: reaction === "love" ? "favorite" : "favorite_border",
            title: translate("$__love", 1),
            color: reaction === "love" ? customApp("menu") : customApp("medium"),
        },
        {
            type: "approve",
            icon: "verified",
            title: translate("$__approve", 1),
            color: reaction === "approve" ? "green" : customApp("medium"),
        },
        {
            type: "attention",
            icon: "report_problem",
            title: translate("$__attention", 1),
            color: reaction === "attention" ? "red" : customApp("medium"),
        },
    ], [reaction, translate, customApp]);

    // Estilo para cada ícone de reação
    const iconStyle = useMemo(() => ({
        margin: "0 2px",
        cursor: "pointer",
    }), []);

    // Manipulador otimizado para cliques de reação
    const handleReactClick = useCallback((type) => {
        reactThis(type);
        // Manter opções abertas após clicar
        overOptionsHandle(true);
    }, [reactThis, overOptionsHandle]);

    // Não mostrar se não houver hover, se não aceitar reações, ou se a mensagem foi deletada
    if (!overOptions || props.noReactions || storie.deleted) {
        return null;
    }

    return (
        <div
            style={reactionButtonStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {reactionIcons.map((item) => (
                <div
                    key={item.type}
                    style={iconStyle}
                    onMouseEnter={handleMouseEnter}
                >
                    <Icon
                        icon={item.icon}
                        title={item.title}
                        iconColor={item.color}
                        size={"18px"}
                        onClick={() => handleReactClick(item.type)}
                    />
                </div>
            ))}

            {storie?.user?._id === session._id && (
                <div style={iconStyle} onMouseEnter={handleMouseEnter}>
                    <Icon
                        icon="forward"
                        title={translate("$__forwardThisMessage", 1)}
                        iconColor={"deepskyblue"}
                        size={"18px"}
                        onClick={() => {
                            setForward(true);
                            overOptionsHandle(true);
                        }}
                    />
                </div>
            )}

            <div style={iconStyle} onMouseEnter={handleMouseEnter}>
                <Icon
                    icon="reply"
                    title={translate("$__replyThisMessage", 1)}
                    iconColor={"deepskyblue"}
                    size={"18px"}
                    onClick={() => {
                        props.reduxFunction("ASYNC", "SET_CHATS", {
                            ...reduxStore.getState().chats,
                            drafts: {
                                ...reduxStore.getState().chats.drafts || {},
                                [props.nodeId]: {
                                    ...reduxStore.getState().chats.drafts?.[props.nodeId] || {},
                                    reply: storie._id,
                                }
                            }
                        });
                        overOptionsHandle(true);
                    }}
                />
            </div>

            {canDelete && (
                <div style={iconStyle} onMouseEnter={handleMouseEnter}>
                    <CustomButton
                        id={`chat_message_delete`}
                        title={translate(`$__delete`, "*")}
                        color={'red'}
                        icon={"delete_forever"}
                        onClick={cancelConfirm}
                        size={"18px"}
                        transparent
                    />
                </div>
            )}

            <div style={{ clear: "both" }}></div>
        </div>
    );
});

// Componente otimizado para mostrar contadores de reações
const ReactionCounters = memo(({ storie, classes, customApp }) => {
    // Verificar se existem reações
    const hasReactions = useMemo(() =>
        storie._reactions && Object.keys(storie._reactions).length > 0,
        [storie._reactions]
    );

    // Tipos de reação possíveis
    const reactionTypes = useMemo(() => [
        { type: 'like', icon: 'thumb_up', color: customApp("menu") },
        { type: 'nolike', icon: 'thumb_down', color: customApp("medium") },
        { type: 'love', icon: 'favorite', color: customApp("medium") },
        { type: 'approve', icon: 'verified', color: 'green' },
        { type: 'attention', icon: 'report_problem', color: 'red' }
    ], [customApp]);

    // Estilo para o container de contadores
    const counterContainerStyle = useMemo(() => ({
        display: "flex",
        alignItems: "center",
        margin: "0 2px"
    }), []);

    // Estilo para cada botão de reação
    const buttonStyle = useMemo(() => ({
        fontSize: "12px",
        margin: 0,
        padding: "0 2px"
    }), []);

    // Função para criar o conteúdo dos tooltips
    const createTooltipContent = useCallback((reactions, type) => (
        <React.Fragment>
            <div className={classes.users}>
                {Object.keys(reactions)
                    .sort((a, b) => {
                        const aDate = reactions[a]?.reactDate?.low;
                        const bDate = reactions[b]?.reactDate?.low;
                        if (aDate && bDate) {
                            return parseInt(aDate) - parseInt(bDate);
                        }
                        return 0;
                    })
                    .map(userId => {
                        const reaction = reactions[userId];
                        return (
                            <div key={userId} style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                <Avatar
                                    alt={reaction.name}
                                    src={reaction.image || defaultAvatar}
                                />
                                <span style={{ paddingLeft: "7px" }}>
                                    {reaction.displayName || reaction.name}
                                    {reaction.reactDate?.low &&
                                        ` (${moment(reaction.reactDate.low * 1000).tz("America/Sao_Paulo").format("DD/MM/YYYY H:mm")})`
                                    }
                                </span>
                            </div>
                        );
                    })
                }
                <div style={{ clear: "both" }}></div>
            </div>
        </React.Fragment>
    ), [classes.users]);

    // Pré-processamento para verificar quais tipos de reações existem
    const visibleReactions = useMemo(() => {
        if (!hasReactions) return [];

        return reactionTypes.filter(({ type }) => {
            const reactions = storie._reactions?.[type];
            return reactions && Object.keys(reactions).length > 0;
        });
    }, [hasReactions, reactionTypes, storie._reactions]);

    // Verificação antecipada
    if (!hasReactions || visibleReactions.length === 0) {
        return null;
    }

    return (
        <div style={counterContainerStyle}>
            {visibleReactions.map(({ type, icon, color }) => {
                const reactions = storie._reactions[type];
                const count = Object.keys(reactions).length;

                return (
                    <IconButton
                        key={type}
                        icon={icon}
                        iconColor={color}
                        title={createTooltipContent(reactions, type)}
                        style={buttonStyle}
                    />
                );
            })}
            <div style={{ clear: "both" }}></div>
        </div>
    );
});

const useStyles = makeStyles(styles);


const Message = memo((props) => {
    const { storie } = props
    const classes = useStyles()

    // Seletores otimizados com shallow equal
    const session = useSelector((state) => state.session);
    const db = useSelector((state) => state.db);
    const functions = useSelector((state) => state.functions);
    const timeline = useSelector((state) => state.timeline);
    const chat = useSelector((state) => state.chat);

    const { socket } = functions

    // Estados locais
    const [hideImage, setHideImage] = useState(false)
    const [overOptions, setOverOptions] = useState(false)
    const [cancelReason, setCancelReason] = useState(null)
    const [goCancel, setGoCancel] = useState(null)
    const [forward, setForward] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)
    const [forwardToId, setForwardToId] = useState(null)
    const [reactionHighlight, setReactionHighlight] = useState(false) // Estado para controlar o destaque da reação

    const mounted = useRef(true)
    const messageRef = useRef()
    const sizeRef = useRef(0)
    const timer = useRef(null)
    const highlightTimer = useRef(null) // Timer para controlar o destaque

    useEffect(() => {
        mounted.current = true
        return () => {
            // Marca componente como desmontado para evitar atualizações de estado após desmonte
            mounted.current = false

            // Limpa o timer de hover para evitar memory leaks
            if (timer.current) {
                clearTimeout(timer.current)
            }

            // Limpa o timer de highlight para evitar memory leaks
            if (highlightTimer.current) {
                clearTimeout(highlightTimer.current)
            }
        }
    }, [])

    useEffect(() => {
        if (mounted.current && props.onResize && messageRef?.current?.clientHeight) {
            if (sizeRef.current !== messageRef.current.clientHeight) {
                sizeRef.current = messageRef.current.clientHeight
                props.onResize(messageRef.current.clientHeight || 83)
            }
        }
    }, [messageRef, props.onResize])

    // Early returns otimizados
    if (storie.filesCount
        && storie.filesCount > 0
        && storie.user
        && storie.user._id
        && storie.user._id !== session._id
        && (
            !storie.files
            || (
                storie.files
                && storie.files.length < storie.filesCount
            )
        )) {
        return null;
    }

    if (!storie) {
        return null;
    }

    // Funções memoizadas com useCallback para gerenciar o estado de hover
    const overOptionsHandle = useCallback((mouse = false) => {
        if (mounted.current) {
            setOverOptions(true)
            // Se o mouse estiver sobre o elemento, limpa o timeout para evitar fechamento
            if (mouse && timer.current) {
                clearTimeout(timer.current)
                timer.current = null
            }
        }
    }, [])

    // Função aprimorada para fechamento com timeout
    const closeOptionsHandle = useCallback((time = 1500) => {
        // Sempre limpe o timeout atual para evitar múltiplos timeouts concorrentes
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }

        // Inicie um novo timeout para fechar as opções
        timer.current = setTimeout(() => {
            if (mounted.current) {
                setOverOptions(false);
            }
        }, time);
    }, [])

    const reactThis = useCallback((react) => {
        // Salvar a posição atual do scroll - usando várias opções para compatibilidade entre navegadores
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

        const nodeId = props.storie.idRel ? props.storie.idRel : props.storie._parent ? props.storie._parent : chat.nodeId;

        const data = {
            chatId: reduxStore.getState().chat.id,
            react: react,
            user: session._id,
            db: props.db,
            nodeId: nodeId,
            message: props.storie._id
        }

        // Ativar o efeito de destaque visual
        if (mounted.current) {
            // Limpar o timer anterior se existir
            if (highlightTimer.current) {
                clearTimeout(highlightTimer.current);
            }

            // Ativar o efeito de destaque
            setReactionHighlight(true);

            // Remover o efeito após 1.5 segundos
            highlightTimer.current = setTimeout(() => {
                if (mounted.current) {
                    setReactionHighlight(false);
                }
            }, 1500);
        }

        interact(props, data)
        socket.emit("data", {
            module: "timeline",
            method: "post",
            action: "interact"
        }, data)

        // Restaurar a posição do scroll após o processamento
        // Usar requestAnimationFrame para garantir que a restauração ocorra após a próxima renderização
        requestAnimationFrame(() => {
            window.scrollTo({
                top: scrollPosition,
                behavior: 'auto' // Usar 'auto' para evitar animação
            });

            // Dupla confirmação para garantir compatibilidade total entre navegadores
            setTimeout(() => {
                window.scrollTo({
                    top: scrollPosition,
                    behavior: 'auto'
                });
            }, 10);
        });
    }, [props, chat.nodeId, session._id, socket])

    const cancelConfirm = useCallback(() => {
        appAlert({
            message: translate('$__confirmCancel', 1),
            variant: 'warning',
            persist: false,
            horizontal: 'right',
            confirm: () => {
                deleteMessage(props, {
                    id: storie._id,
                    idRel: storie.idRel,
                    deletedReason: cancelReason,
                    deleted: true
                })
                storie.deleted = true
                setGoCancel(false)
                setCancelReason(null)
            }
        })
    }, [props, storie, cancelReason])

    // Valores memoizados
    const time = useMemo(() => {
        if (storie.type === "timer" && String(storie.ini) && String(storie.fin)) {
            return storie.fin - storie.ini;
        }
        return "";
    }, [storie.type, storie.ini, storie.fin]);

    const urlPreview = useMemo(() => {
        return storie.urlPreview ? JSON.parse(storie.urlPreview) : null;
    }, [storie.urlPreview]);

    const message = useMemo(() => {
        return translate(mentionedUsers(storie.message, storie));
    }, [storie.message, storie]);

    const reaction = useMemo(() => {
        if (!storie._reactions || Object.keys(storie._reactions).length === 0) {
            return null;
        }

        for (const reactionType of Object.keys(storie._reactions)) {
            if (Object.keys(storie._reactions[reactionType]).length > 0) {
                for (const userId of Object.keys(storie._reactions[reactionType])) {
                    if (userId === session._id) {
                        return reactionType;
                    }
                }
            }
        }
        return null;
    }, [storie._reactions, session._id]);

    const my = useMemo(() => {
        return props.storie?.user?._id === session._id;
    }, [props.storie?.user?._id, session._id]);

    // Estilos memoizados
    const messageStyles = useMemo(() => ({
        container: {
            maxWidth: "calc(100% - 15px)",
            marginLeft: "7px",
            ...props.messageClick ? { cursor: "pointer" } : {},
            ...props.boxStyle ? props.boxStyle : {}
        },
        messageBox: {
            position: "relative",
            maxWidth: "calc(88% - 15px)",
            float: my ? "right" : "left",
            ...my ? { marginRight: "15px" } : { marginLeft: "15px" },
            width: "auto",
            minWidth: "303px",
            marginBottom: "20px",
            transition: "all 0.3s ease-in-out" // Adiciona transição suave
        },
        messageContent: {
            position: "relative",
            float: my ? "right" : "left",
            padding: "7px 15px",
            width: "100%",
            background: reactionHighlight
                ? (my
                    ? "linear-gradient(33deg, rgba(220, 235, 255, 1), rgba(190, 215, 255, 1))" // Destaque azulado mais forte para mensagens próprias
                    : "linear-gradient(33deg, rgba(230, 250, 230, 1), rgba(210, 235, 210, 1))") // Destaque esverdeado mais forte para mensagens de outros
                : (my
                    ? "linear-gradient(33deg, rgba(237, 237, 237, 1), rgba(196, 196, 196, 1))"
                    : "linear-gradient(33deg, rgba(250, 250, 250, 1), rgba(240,240,240, 1))"),
            borderRadius: "15px",
            boxShadow: reactionHighlight
                ? (my
                    ? "rgba(0, 100, 255, 0.25) 0px 2px 6px 3px" // Sombra azulada mais forte para mensagens próprias
                    : "rgba(0, 150, 0, 0.25) 0px 2px 6px 3px") // Sombra esverdeada para mensagens de outros
                : "rgb(0 0 0 / 5%) 0px 2px 2px 2px",
            transform: reactionHighlight ? "scale(1.01)" : "scale(1)", // Efeito sutil de "pulsar"
            transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)", // Easing mais dinâmico
            ...storie.approval ? {
                border: `solid 4px ${storie.message.indexOf("$__approved") > -1 ? `green` : `red`}`
            } : {}
        },
        userNameStyle: {
            position: "relative",
            width: "100%",
            fontWeight: "bold",
            fontSize: "12px",
            color: customApp('menu'),
        },
        avatarPosition: {
            position: "absolute",
            ...my ? { right: "-20px" } : { left: "-20px" },
            bottom: 0,
        },
        timestampArea: {
            position: "absolute",
            ...my ? { left: "15px" } : { right: "15px" },
            bottom: "-26px",
            color: "rgba(0,0,0,0.77)",
            background: "linear-gradient(33deg, rgba(233, 233, 233, 1), rgba(211,211,211, 1))",
            display: "flex",
            padding: "1px 7px",
            alignItems: "center",
            borderRadius: "0 0 7px 7px",
            fontSize: "10px",
            width: "fit-content",
        }
    }), [my, props.messageClick, props.boxStyle, storie.approval, storie.message, reactionHighlight]);

    const displayUserName = useMemo(() => {
        return (
            !session.GlobalData.hideDeletedUsers
            ||
            (
                session?.GlobalData?.hideDeletedUsers
                && storie.user
                && (
                    !storie.user.deleted
                    && (
                        !reduxStore.getState().db.users[storie.user._id]
                        || (
                            reduxStore.getState().db.users[storie.user._id]
                            && !reduxStore.getState().db.users[storie.user._id].deleted
                        )
                    )
                )
            )
        ) && storie.user.name ? storie.user.name : translate("$__deletedUser");
    }, [session.GlobalData, storie.user]);

    const timeDisplay = useMemo(() => {
        const messageTime = moment(storie.created_at * 1000).tz("America/Sao_Paulo");
        const now = moment().tz("America/Sao_Paulo");

        if (now.format("DD/MM/YYYY") === messageTime.format("DD/MM/YYYY")) {
            return messageTime.format("H:mm");
        } else if (now.format("YYYY") === messageTime.format("YYYY")) {
            return messageTime.format("DD/MM H:mm");
        } else {
            return messageTime.format("DD/MM/YYYY H:mm");
        }
    }, [storie.created_at]);

    const renderMessage = useCallback(() => {
        if (storie.type === "comment" && storie.message) {
            return (
                <div style={{ padding: 10 }}>
                    {storie.urlPreview && urlPreview.img && urlPreview.title && urlPreview.contentSnippet ?
                        <GridContainer style={{ marginBottom: 15 }}>
                            {!hideImage && urlPreview.img &&
                                <GridItem
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    xl={2}
                                >
                                    <img
                                        style={{
                                            width: "-webkit-fill-available"
                                        }}
                                        src={`${urlPreview.img}`}
                                        onError={(e) => {
                                            if (mounted.current)
                                                setHideImage(true)
                                        }}
                                        alt={urlPreview.title || urlPreview.link}
                                    />
                                </GridItem>
                            }
                            <GridItem
                                xs={12}
                                sm={6}
                                md={8}
                                lg={9}
                                xl={10}
                            >
                                <div style={{
                                    fontSize: "14px",
                                    color: customApp("menu"),
                                    fontWeight: "bold"
                                }}>{urlPreview.title}</div>
                                {urlPreview.site && <div
                                    style={{
                                        fontSize: "12px",
                                    }}
                                >{urlPreview.site}</div>}
                                {urlPreview.contentSnippet && <div
                                    style={{
                                        fontSize: "12px",
                                        color: "gray",
                                    }}>{urlPreview.contentSnippet}</div>}
                                <a style={{
                                    marginTop: "15px",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                }
                                } href={urlPreview.link} target="_blank" rel="noopener noreferrer">{translate("$__openLink", "*")}</a>
                            </GridItem>
                        </GridContainer>
                        : <React.Fragment></React.Fragment>}
                    <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                    >
                        {Highlighted(links(message), props.searchText)}
                    </GridItem>
                    <div style={{ clear: "both" }}></div>
                </div>
            )
        } else if (storie.type === "comment" && !storie.message && storie.cardId !== props.nodeId && reduxStore.getState().db.cards[storie.cardId]) {
            return (
                <Card db="cards" data={reduxStore.getState().db.cards[storie.cardId]} Avatar expanded ignoreList />
            )
        }
        if (storie.type === "log") {
            let newData = {}
            if (storie.message === "$__stepChangeListPosition" && storie.newData) {
                // console.log(storie.newData)
                let positions = JSON.parse(storie.newData)
                return (
                    <div>
                        <div style={{ position: "relative", width: "100%", display: "flex" }}>
                            <Icon color="color" icon="history" style={{ marginRight: "10px" }} />
                            {storie.message.indexOf("$__") > -1 ? translate(storie.message, 1) : storie.message}{` `}
                        </div>
                        <ul
                            style={{
                                listStyle: "decimal"
                            }}
                        >
                            {positions.filter(a => reduxStore.getState().db.cards[a]).map(a => (
                                <li>{reduxStore.getState().db.cards[a].name}</li>
                            ))}

                        </ul>
                    </div>
                )
            }
            if (storie.message === "$__updated") {
                newData = JSON.parse(storie.newData)
                return (
                    <div>

                        <div style={{ position: "relative", width: "100%", display: "flex" }}>
                            <Icon color="color" icon="history" style={{ marginRight: "10px" }} />
                            {storie.message.indexOf("$__") > -1 ? translate(storie.message, 1) : storie.message}{` `}
                        </div>
                        {storie.newData &&
                            <ul style={{
                                position: "relative",
                                width: "98%"

                            }}>
                                {Object.keys(newData).map((a, i) => {
                                    if (a === "icon") {
                                        return (
                                            <li key={i} style={{ display: "flex" }}>
                                                {translate(`$__icon`, 1)}:<Icon icon={newData[a]} color={customApp("color")} size={"17px"} />
                                            </li>
                                        )
                                    } else
                                        if (a === "customColumns") {
                                            let columns = JSON.parse(newData[a])
                                            return (<li key={i}>{translate(`$__customColumns`, 1)}:
                                                <ul>
                                                    {Object.keys(columns).map((a, ai) =>
                                                        <li key={ai}>{translate(`$__${a}`)}{`=>`} <span style={{ color: customApp('menu'), fontWeight: "bold" }}>{translate(`${columns[a].name}`)}</span></li>
                                                    )}

                                                </ul>
                                            </li>)
                                        } else if (a === "customDashboard") {
                                            return (<li key={i}>{translate(`$__customDashboard`, 1)}: {translate(`$__updated`, 1)}</li>)
                                        } else if (
                                            a === "_id"
                                            || a === "id"
                                            || a === "client"
                                            || a === "planId"
                                            || a === "_parent"
                                            || a === "owner"
                                            || a === "image"
                                        ) {
                                        } else if (a === "status") {
                                            return (<li key={i}>{translate(`$__status`, 1)}: {translate(`$__${newData[a]}`, 1)}</li>)
                                        } else if (a === 'note') {
                                            return (<li key={i}>{translate(`$__note`, 1)}: <div>{Highlighted(links(newData[a]), props.searchText)}</div></li>)
                                        } else if (
                                            a === "kpi_type"
                                            || a === "priority"
                                            || a === "risk"
                                            || a === "complexity"
                                            || a === "impact"
                                        ) {
                                            return (<li key={i}>{translate(`$__${a}`, 1)}: {translate(`$__${newData[a]}`, 1)}</li>)
                                        } else if (
                                            a === "name" || a === 'description'
                                        ) {
                                            return (
                                                <li key={i}>{translate(`$__${a}`, 1)}: {newData[a]}</li>
                                            )
                                        } else if (
                                            a === "url"
                                        ) {
                                            return (
                                                <li key={i}>{"url"}:
                                                    <a href={newData[a]} target="blank"
                                                        style={{

                                                        }}
                                                    >
                                                        {Highlighted(links(newData[a]), props.searchText)}
                                                    </a>
                                                </li>
                                            )
                                        } else if (
                                            a !== "_tags"
                                            && (typeof newData[a] === "string")
                                            && (
                                                a !== "kpi_ini"
                                                && a !== "kpi_fin"
                                                && a !== "startDate"
                                                && a !== "endDate"
                                                && a !== "updated_at"
                                                && a !== "created_at"
                                                && a !== "content"
                                            )
                                        ) {
                                            return (
                                                <li key={i}>{translate(`$__${a}`, 1)}: {newData[a].indexOf("$__") > -1 ? translate(`$__${newData[a]}`, 1) : newData[a]}</li>
                                            )
                                        } else if (
                                            a === "kpi_ini"
                                            || a === "kpi_fin"
                                        ) {
                                            return (
                                                <li key={i}>{translate(`$__${a}`, 1)}: {formatNumber(newData[a], storie.kpi_type ? storie.kpi_type : "decimal")}</li>
                                            )
                                        } else if (
                                            a === "startDate"
                                            || a === "endDate"
                                            || a === "updated_at"
                                            || a === "created_at"
                                            || a === "completed_at"
                                        ) {
                                            return (
                                                <li key={i}>{translate(`$__${a}`, 1)}: {!newData[a] ? translate("$__removed") : moment(new Date(newData[a] * 1000)).tz("America/Sao_Paulo").format("DD/MM/YYYY HH:mm")}</li>
                                            )
                                        } else if (
                                            typeof newData[a] === "boolean"
                                        ) {
                                            return (
                                                <li key={i}>{translate(`$__${a}`, 1)}: {newData[a] ? translate(`$__enable`, 1) : translate(`$__disable`, 1)}</li>
                                            )
                                        } else if (a === "_tags") {
                                            return (<li key={i}>TAGS: <CardTags options={newData[a]} showOptions={true} /></li>)
                                        } else {
                                            return (<li key={i}>{translate(`$__${a}`, 1)}::UPDATED_VALUE</li>)
                                        }
                                    return (<li key={i}>{translate(`$__${a}`, 1)}::UPDATED_VALUE</li>)
                                }
                                )}
                                <div style={{ clear: "both" }}></div>
                            </ul>
                        }
                        <div style={{ clear: "both" }}></div>
                    </div>
                )
            } else {
                return (
                    <div style={{ position: "relative", width: "100%" }}>
                        <div style={{ position: "relative", width: "100%", display: "flex" }}>
                            <Icon color="color" icon="history" style={{ marginRight: "10px" }} />
                            {storie.approval && storie.message.indexOf("$__approved") > -1 ?
                                <Icon icon="verified" color={"green"} />
                                : storie.approval && storie.message.indexOf("$__rejected") > -1 ?
                                    <Icon icon="gpp_bad" color={"red"} />
                                    : <React.Fragment></React.Fragment>
                            }
                            <div style={{ wordBreak: "break-word" }}>
                                {Highlighted(links(message), props.searchText)}
                            </div>
                            <div style={{ clear: "both" }}></div>
                        </div>
                        {storie.cardId ?
                            <div
                                style={{
                                    position: "relative",
                                    maxWidth: "285px",
                                    ...props.boxStyle && props.boxStyle.maxWidth ? { maxWidth: props.boxStyle.maxWidth } : {},
                                    width: "100%",
                                    display: "block"
                                }}>
                                <Card
                                    db="cards"
                                    data={reduxStore.getState().db.cards[storie.cardId]}
                                    ignoreList
                                    onlyOption
                                    notGlobalExpanded
                                    noExpanding
                                    disabled
                                />
                            </div>
                            : <React.Fragment></React.Fragment>
                        }
                        <div style={{ clear: "both" }}></div>
                    </div>
                )
            }
        }
        if (storie.type === "timer") {
            // if (storie.message === "Dsf")
            //     console.log(storie)
            let diff = time
            let diffText = ``
            if (time < 60) {
                diffText = `${diff} ${translate("$__seconds", 1)}`
            } else if (time > 3600) {
                let hours = Math.trunc(diff / 3600)
                diff = diff - (hours * 3600)
                let minutes = Math.trunc(diff / 60) > 0 ? Math.trunc(diff / 60) : 0
                diff = diff - (minutes * 60)
                let seconds = diff > 0 ? diff : 0
                diffText = `${hours} hora${hours > 1 ? "s" : ""} ${minutes} ${translate("$__minutes", 1)} ${seconds} ${translate("$__seconds", 1)}`
            } else {
                let minutes = Math.trunc(diff / 60) > 0 ? Math.trunc(diff / 60) : 0
                diff = diff - (minutes * 60)
                let seconds = diff > 0 ? diff : 0
                diffText = `${minutes} ${translate("$__minutes", 1)} ${seconds} ${translate("$__seconds", 1)}`
            }
            if (goCancel)
                return (
                    <div>
                        <div style={{ position: "relative", width: "100%", marginTop: "33px" }}>
                            <TextField
                                label={translate('$__cancelReason', 1)}
                                variant={customApp('standard')}
                                name="cancelReason"
                                InputProps={{
                                    autoComplete: 'new-password',
                                    multiline: true,
                                    minRows: 3,
                                    onChange: (d) => {
                                        if (mounted.current)
                                            setCancelReason(d.target.value)
                                    },
                                }}
                                placeholder={translate('$__cancelReason_placeholder', 1)}
                            />
                        </div>
                        <div style={{ position: "absolute", right: "7px", top: "7px", display: 'flex' }}>
                            <CustomButton
                                transparent
                                title={translate(`$__cancel`, '*')}
                                color={customApp('lightgrey')}
                                icon={'cancel'}
                                onClick={() => {
                                    if (mounted.current) {
                                        setGoCancel(false)
                                        setCancelReason(null)
                                    }
                                }}
                                size={'25px'}
                            />
                            <CustomButton
                                transparent
                                title={translate(`$__save`, 1)}
                                color='green'
                                icon={'playlist_add_check'}
                                onClick={() => {
                                    if (mounted.current)
                                        cancelConfirm()
                                }}
                                size={'25px'}
                            />
                        </div>
                        <div style={{ clear: "both" }}></div>
                    </div>
                )
            return (
                <div>
                    <div
                        style={{
                            position: "relative",

                        }}
                    >
                        {storie && storie._toUser && Object.keys(storie._toUser).length > 0 &&
                            <div className={classes.timeInfo}>
                                <AvatarGroup
                                    max={300}
                                    style={{
                                        flexWrap: "wrap",
                                        display: "inline-flex",
                                        border: "none"
                                    }}
                                >
                                    {Object.keys(storie._toUser).map(selectedUserId =>
                                        <Tooltip
                                            key={selectedUserId}
                                            title={storie._toUser[selectedUserId].displayName ? storie._toUser[selectedUserId].displayName : storie._toUser[selectedUserId].name}
                                        >
                                            <Avatar
                                                alt={storie._toUser[selectedUserId].name}
                                                src={storie._toUser[selectedUserId].image || null}
                                                style={{ width: 27, height: 27, border: "none" }}>
                                                {storie._toUser[selectedUserId].name.substr(0, 1)}
                                            </Avatar>
                                        </Tooltip>
                                    )}
                                </AvatarGroup>
                            </div>
                        }
                        {storie.manualEntry ?
                            <div className={classes.timeInfo}>
                                <Icon color="color" icon="schedule" />
                                <div className="text">{moment(storie.ini * 1000).tz("America/Sao_Paulo").format("DD/MM/YYYY")}</div>
                            </div>
                            : <React.Fragment>
                                {parseInt(moment(storie.ini * 1000).tz("America/Sao_Paulo").format("YYYY")) > 2021 ?
                                    <div className={classes.timeInfo}>
                                        <Icon color="color" icon="schedule" />
                                        <div className="text">{moment(storie.ini * 1000).tz("America/Sao_Paulo").format("YYYY/MM/DD HH:mm:ss")}</div>
                                    </div>
                                    :
                                    <React.Fragment></React.Fragment>
                                }
                                {parseInt(moment(storie.fin * 1000).tz("America/Sao_Paulo").format("YYYY")) > 2021 ?
                                    <div className={classes.timeInfo}>
                                        <Icon color="color" icon="watch_later" />
                                        <div className="text">{moment(storie.fin * 1000).tz("America/Sao_Paulo").format("YYYY/MM/DD HH:mm:ss")}</div>
                                    </div>
                                    :
                                    <React.Fragment></React.Fragment>
                                }
                            </React.Fragment>
                        }

                        <div className={classes.timeInfo}>
                            <Icon color="color" icon="hourglass_full" />
                            <div className="text">
                                {diffText}
                            </div>
                        </div>
                        <div style={{ clear: 'both' }}></div>
                        {storie.deleted ? <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(255,255,255,0.66)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontWeight: "bold",
                                color: customApp("menu")
                            }}
                        >
                            {translate("$__cancelled")}
                        </div> : <React.Fragment></React.Fragment>}
                    </div>
                    <div>{message}</div>
                    {storie.deleted && storie.deletedReason &&
                        <div style={{ color: "red" }}>{translate("$__cancelReason", 1)}: {storie.deletedReason}</div>
                    }
                    <div style={{ clear: "both" }}></div>
                    {
                        (
                            !storie.deleted &&
                            (
                                overOptions ||
                                (
                                    moment(storie.created_at).unix('x')
                                )
                            )
                        ) ?
                            <div style={{ position: "absolute", right: "7px", top: "7px" }}>
                                <MoreVert
                                    transparent
                                    options={[
                                        {
                                            name: "$__cancelThis",
                                            icon: "cancel",
                                            onClick: () => {
                                                setGoCancel(true)
                                            },
                                            show: "hover"
                                        },
                                    ]}
                                />
                                <div style={{ clear: "both" }}></div>
                            </div>
                            : <React.Fragment></React.Fragment>
                    }
                    <div style={{ clear: "both" }}></div>
                </div>
            )
        }
        if (storie.type === "kpi") {
            let balance = storie && storie.balance ? storie.balance : 0
            return (
                <div>
                    {storie.cardId ? <Card db="cards" data={reduxStore.getState().db.cards[storie.cardId]} ignoreList noOptions /> : <React.Fragment></React.Fragment>}
                    <div>{message}</div>
                    <div className={parseFloat(storie.value) > 0 ? classes.valuePositive : classes.valueNegative}>{formatNumber(storie.value, storie.kpi_type ? storie.kpi_type : "decimal")}</div>

                    {!props.stories &&
                        <div className={classes.lastValue}>{translate("$__balance", 1)}: {formatNumber(balance, storie.kpi_type ? storie.kpi_type : "decimal")}</div>
                    }
                    <div style={{ clear: "both" }}></div>
                </div>
            )
        }
    }, [storie, props, session, my, time, urlPreview, message, hideImage, goCancel, cancelReason, classes, translate]);


    if (!storie.filesCount && storie.message === "" && storie.cardId && storie.cardId !== props.nodeId && !reduxStore.getState().db.cards[storie.cardId])
        return <></>

    if (storie.deleted && storie.user._id !== session._id)
        return <></>



    const renderFile = useCallback((file) => {
        let fileName = file.name.split(".")
        let ext = fileName[fileName.length - 1]

        let img = `attachment`
        if (db.fileExtensions.filter(a => a.ext.indexOf(ext.toLowerCase()) > -1).length > 0) {
            img = db.fileExtensions.filter(a => a.ext.indexOf(ext.toLowerCase()) > -1)[0].icon
                || `https://fl.machen.ai/?arq=${file.file.replace('&', '||MCH-ECOM||')}&name=${file.name.replace('&', '||MCH-ECOM||')}`
        }

        let viewer = "img"
        if (db.fileExtensions.filter(a => a.ext.indexOf(ext.toLowerCase()) > -1).length > 0 && db.fileExtensions.filter(a => a.ext.indexOf(ext.toLowerCase()) > -1)[0].viewer)
            viewer = db.fileExtensions.filter(a => a.ext.indexOf(ext.toLowerCase()) > -1)[0].viewer

        return (
            <div key={file._id}
                style={{
                    position: "relative",
                    display: "flex",
                    marginBottom: "5px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                    overflow: "hidden",
                    padding: "7px",
                    zIndex: "10 !important",
                    borderRadius: "15px",
                    alignItems: "center",
                    justifyContent: "center",
                    ...viewer === "audio" ? {
                        width: "350px",
                        height: "50px",
                    } : viewer === "movie" ? {
                        width: "350px",
                        height: "280px",
                    } : {
                        width: "150px",
                        height: "150px",
                    }
                }}
                onClick={(e) => {
                    if (props.openLightBox) {
                        props.openLightBox(file._id)
                    }
                    e.preventDefault()
                }}
                title={file.name}
            >
                {(viewer === "img"
                    ||
                    (
                        (
                            viewer !== "movie"
                            && viewer !== "audio"
                            && typeof img === "string"
                            && img.indexOf("blob:") === -1
                            && img.indexOf("svg") === -1
                        )
                        || (
                            viewer !== "movie"
                            && viewer !== "audio"
                            && !(viewer === "img" && img && img.indexOf("svg") > -1)
                        )
                    )) &&
                    <Tooltip
                        title={file.name}>
                        <div style={{
                            position: "absolute",
                            bottom: "7px",
                            left: "7px",
                            right: "7px",
                            padding: "3px",
                            background: "rgba(0,0,0,0.8)",
                            color: "#FFFFFF",
                            borderRadius: "0px 0px 15px 15px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}>{file.name}</div>
                    </Tooltip>
                }
                {/* IMAGES */}
                {(viewer === "img" && img === "attachment") &&
                    <Icon icon={img} size="50px" />
                }
                {(viewer === "img"
                    &&
                    (
                        typeof img === "string"
                        && img.indexOf("https") > -1
                        && img.indexOf("svg") === -1
                    )
                ) &&
                    <img
                        alt="altImage"
                        src={`${img}`}
                        style={
                            {
                                borderRadius: "15px",
                                boxShadow: `0 1px 2px 2px rgba(0,0,0,0.1)`,
                                maxWidth: "100%",
                                height: "100%",
                                maxHeight: "33vh"
                            }}
                        onError={(e) => {
                            // if (
                            //     storie.created_at
                            //     && typeof storie.created_at === "string"
                            //     && parseInt(storie.created_at) > moment().unix("X") - 60
                            // )
                            //     e.target.src = img
                        }
                        }
                    />
                }

                {(viewer !== "movie" && viewer !== "img" && typeof img === "string" && img.indexOf("blob:") === -1 && img.indexOf("svg") === -1) ?
                    <Icon icon={img} size="50px" />
                    : (viewer !== "movie" && viewer !== "img" && !(viewer === "img" && img && img.indexOf("svg") > -1)) ?
                        <img alt="MACHEN_IMAGE" src={img} style={{ width: "100%", height: "100%" }} />
                        : <React.Fragment></React.Fragment>
                }

                {/* IMAGES */}
                {(viewer === "img" && img && img.indexOf(".svg") > -1) ?
                    <img
                        alt="altImage"
                        src={SVGIcon}
                        style={
                            {
                                borderRadius: "15px",
                                boxShadow: `0 1px 2px 2px rgba(0,0,0,0.1)`,
                                maxWidth: "100%",
                                height: "100%",
                                maxHeight: "33vh"
                            }}
                    />
                    : <React.Fragment></React.Fragment>
                }

                {viewer === "movie"
                    &&
                    <video
                        style={{
                            width: "100%"
                        }}
                        controlsList="nodownload"
                        src={`https://machen.azureedge.net/${file.file}`} ></video>
                }
                {viewer === "audio"
                    &&
                    <ReactAudioPlayer
                        src={`https://machen.azureedge.net/${file.file}`}
                        // autoPlay
                        controls
                    />
                }
                <div style={{ clear: "both" }}></div>
            </div>
        )
    }, [props, translate])

    return (
        <div
            style={messageStyles.container}
            onClick={props.messageClick ? (e) => {
                props.messageClick()
                e.preventDefault()
            } : null}
            ref={messageRef}
        >
            <div
                className="message"
                style={messageStyles.messageBox}
                onMouseLeave={() => { closeOptionsHandle(1000) }}
                onMouseOver={() => {
                    if (!props.isReply)
                        overOptionsHandle(true)
                }}
                onClick={() => {
                    if (!props.isReply)
                        overOptionsHandle(true)
                }}
            >
                {(props.showUserName && !my) &&
                    <div style={messageStyles.userNameStyle}>
                        {displayUserName}
                    </div>
                }
                <div
                    style={messageStyles.messageContent}
                    onMouseEnter={() => overOptionsHandle(true)}
                    onMouseLeave={() => closeOptionsHandle()}>


                    {(storie && storie.filesCount && storie && storie.user && storie.user._id === session._id && parseInt(storie.filesCount) > 0 && storie.files && Object.keys(storie.files).length === 0) ?
                        <React.Fragment>
                            <div style={{
                                position: "relative",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "lightgray",
                            }}>
                                {translate(`$__transferringFile${parseInt(storie.filesCount) > 1 ? `s` : ``}`)}
                            </div>
                            <div
                                className="files"
                                style={{
                                    position: "relative",
                                    maxWidth: "calc(100% - 15px)",
                                    width: "100%",
                                    display: "flex",
                                }}>
                                {
                                    parseInt(storie.created_at) > moment().unix('x') - 60
                                        ?
                                        <React.Fragment>
                                            {/* HOUVE UM PROBLEMA AO ENVIAR OS ARQUIVOS */}
                                        </React.Fragment>
                                        :
                                        <React.Fragment>

                                        </React.Fragment>
                                }
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment></React.Fragment>
                    }
                    {
                        storie.files && Object.keys(storie.files).length > 0 ?
                            <div className="files"
                                style={{
                                    position: "relative",
                                    maxWidth: "calc(100% - 15px)",
                                    float: my ? "right" : "left",
                                    ...my ? {
                                        marginRight: "15px"
                                    } : {
                                        marginLeft: "15px"
                                    },
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: my ? `flex-end` : `none`,
                                    flexWrap: "wrap"
                                }}>
                                {Object.keys(storie.files).map((id, i) => <div key={`${id}-${i}`}>{renderFile(storie.files[id])}</div>)}
                            </div>
                            : storie.files && storie.files.length > 0 ?
                                <div className="files"
                                    style={{
                                        position: "relative",
                                        maxWidth: "calc(100% - 15px)",
                                        float: my ? "right" : "left",
                                        ...my ? {
                                            marginRight: "15px"
                                        } : {
                                            marginLeft: "15px"
                                        },
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: my ? `flex-end` : `none`,
                                        flexWrap: "wrap"
                                    }}>
                                    {storie.files.map((ff, i) => renderFile(ff))}
                                </div>
                                : <React.Fragment></React.Fragment>
                    }
                    {(!props.isReply
                        && props.storie
                        && props.storie.reply
                        && timeline
                        && (
                            (
                                timeline[props.nodeId]
                                && timeline[props.nodeId][props.storie.reply]
                            ) ||
                            (
                                timeline[session._id]
                                && timeline[session._id][props.storie.reply]
                            )
                        )
                    ) &&
                        <div
                            style={{
                                position: "relative",
                                width: "calc(100% - 20px)",
                                opacity: 0.66,
                                display: "flex",
                                justifyContent: "center",
                                marginBottom: "7px"
                            }}>
                            <ReplyMessage
                                isReply={true}
                                storie={timeline[props.nodeId] && timeline[props.nodeId][props.storie.reply] ? timeline[props.nodeId][props.storie.reply] : timeline[session._id][props.storie.reply]}
                                db={props.db}
                                nodeId={props.nodeId}
                                openLightBox={(e) => {
                                    if (props.openLightBox)
                                        props.openLightBox(e)
                                }}
                                messageClick={() => {
                                    if (props.replyClick)
                                        props.replyClick()
                                }}
                            />
                        </div>
                    }
                    {(!storie.deleted || storie.type === 'timer') ?
                        renderMessage()
                        :
                        <div
                            style={{
                                color: 'lightGray',
                                height: 33,
                                padding: 7,
                            }}
                        >
                            {translate("$__removed", "*")}*
                        </div>
                    }
                </div>
                {
                    (
                        storie.user
                        && storie.user._id
                    ) &&
                    <div style={messageStyles.avatarPosition}>
                        <UserBadge
                            overlap="circular"
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            userId={storie.user._id}
                        >
                            <Avatar
                                {...storie.user._id && !reduxStore.getState().db.users[storie.user._id]?.deleted ?
                                    {
                                        alt: storie.user.displayName ? storie.user.displayName : storie.user.name,
                                        src: `${storie.user.image}`
                                    } : {
                                        alt: translate("$__deletedUser"),
                                        src: null,
                                    }
                                }
                                // alt={storie.user.displayName ? storie.user.displayName : storie.user.name}
                                // src={`${storie.user.image}`}
                                style={{
                                    width: "22px",
                                    height: "22px"
                                }} />
                        </UserBadge>
                    </div>
                }
                <div
                    style={messageStyles.timestampArea}
                    onMouseEnter={() => overOptionsHandle(true)}
                    onMouseLeave={closeOptionsHandle}
                >
                    <ReactionCounters
                        storie={storie}
                        classes={classes}
                        customApp={customApp}
                    />
                    {!props.isReply &&
                        <div
                            style={{
                                position: "relative",
                                float: "left",
                                marginLeft: "7px",
                                marginRight: "7px",
                                // Aumentando a área de clique para facilitar o hover
                                padding: "2px 0"
                            }}
                            onMouseEnter={() => overOptionsHandle(true)}
                        >
                            <ReactionButtons
                                overOptions={overOptions}
                                reaction={reaction}
                                reactThis={reactThis}
                                storie={storie}
                                session={session}
                                setForward={setForward}
                                props={props}
                                closeOptionsHandle={closeOptionsHandle}
                                overOptionsHandle={overOptionsHandle}
                                cancelConfirm={cancelConfirm}
                                translate={translate}
                                customApp={customApp}
                            />
                            <div style={{ clear: "both" }}></div>
                        </div>
                    }
                    <div style={{ clear: "both" }}></div>
                    {timeDisplay}

                    {(
                        storie.readedBy
                        && Object.keys(storie.readedBy).length > 0)
                        &&
                        <Tooltip
                            title={(
                                <React.Fragment>
                                    <div className={classes.users}>
                                        {Object.keys(storie.readedBy)
                                            .sort((a, b) => {
                                                if (storie
                                                    && storie.readedBy[a]
                                                    && storie.readedBy[a].readedDate
                                                    && storie.readedBy[b]
                                                    && storie.readedBy[b].readedDate
                                                    && String(storie.readedBy[a].readedDate.low)
                                                    && String(storie.readedBy[b].readedDate.low)
                                                    && parseInt(storie.readedBy[a].readedDate.low) < parseInt(storie.readedBy[b].readedDate.low)
                                                ) {
                                                    return -1
                                                } else if (storie
                                                    && storie.readedBy[a]
                                                    && storie.readedBy[a].readedDate
                                                    && storie.readedBy[b]
                                                    && storie.readedBy[b].readedDate
                                                    && String(storie.readedBy[a].readedDate.low)
                                                    && String(storie.readedBy[b].readedDate.low)
                                                    && parseInt(storie.readedBy[a].readedDate.low) > parseInt(storie.readedBy[b].readedDate.low)
                                                ) {
                                                    return 1
                                                } else {
                                                    return 0
                                                }
                                            })
                                            .map((a, i) => (
                                                storie.user._id !== a && storie.readedBy && storie.readedBy[a] && storie.readedBy[a].name &&
                                                <div key={a} style={{ position: "relative", display: "flex", alignItems: "center", }}>
                                                    <Avatar alt={storie.readedBy[a].name} src={storie.readedBy[a].image || null} />
                                                    <span style={{ paddingLeft: "7px" }}>
                                                        {storie.readedBy[a].displayName ? storie.readedBy[a].displayName : storie.readedBy[a].name}{storie.readedBy[a].readedDate && storie.readedBy[a].readedDate.low && ` (${moment(storie.readedBy[a].readedDate.low * 1000).tz("America/Sao_Paulo").format("DD/MM/YYYY H:mm")})`}
                                                    </span>
                                                </div>
                                            ))}
                                        <div style={{ clear: "both" }}></div>
                                    </div>
                                </React.Fragment>
                            )
                            }
                        >
                            <div>
                                <Icon color={"#FFFFFF"} size="14px" style={{ marginLeft: "7px" }}>done_all</Icon>
                            </div>
                        </Tooltip>
                    }
                </div>
                <div style={{ clear: "both" }}></div>
            </div >
            {/* {console.log(storie)} */}
            {forward ?
                <Dialog
                    fullWidth={true}
                    // onClose={() => setEditor(false)} 
                    aria-labelledby="simple-dialog-title"
                    open={forward}
                >
                    <div className="forwardMessage">
                        <div style={{ position: "relative", marginLeft: "10px", marginTop: '5px', width: "calc(100% - 10px)" }}>
                            <HeaderWithIcon
                                title={translate("$__forwardMessage", 1)}
                                icon="forward"
                                onCancel={() => { setForward(false) }}
                            />
                        </div>
                        <div style={{ padding: 15 }}>
                            <SelectUsers
                                hideSelected
                                avatarSize="33px"
                                permission={props.permission}
                                noLimit
                                ignoreId={props.nodeId ? props.nodeId : props.storie.idRel ? props.storie.idRel : null}
                                nodeId={props.nodeId}
                                onSelect={(e) => {
                                    setForwardToId(e)
                                }}
                            /></div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "15px" }}>
                            <CustomButton
                                shadow
                                title={translate("$__cancel")}
                                text={translate("$__cancel")}
                                color="lightgrey"
                                icon={"close"}
                                size={"25px"}
                                onClick={() => {
                                    setForward(false)
                                    setForwardToId(null)
                                }}
                            />
                            {forwardToId &&
                                <div style={{ marginLeft: "15px" }}>
                                    <CustomButton
                                        shadow
                                        title={translate("$__forward")}
                                        text={translate("$__forward")}
                                        icon={"forward"}
                                        size={"25px"}
                                        load={saveLoading ? true : false}
                                        onClick={() => {
                                            setSaveLoading(true)
                                            forwardMessage(props, {
                                                ...storie,
                                                _forwardToId: forwardToId
                                            })


                                            setTimeout(() => {
                                                setForward(false)
                                                setForwardToId(null)
                                                props.reduxFunction("ASYNC", "SET_CHAT", {
                                                    ...reduxStore.getState().chat,
                                                    db: 'users',
                                                    nodeId: forwardToId[0],
                                                    loading: false,
                                                })
                                                setSaveLoading(false)
                                                // }
                                            }, 6000)
                                        }}
                                    />
                                    <div style={{ clear: "both" }}></div>
                                </div>
                            }
                            <div style={{ clear: "both" }}></div>
                        </div>
                        <div style={{ clear: "both" }}></div>
                    </div>
                </Dialog>
                : <React.Fragment></React.Fragment>
            }
            <div style={{ clear: "both" }}></div>
        </div>
    );
});

//REACT
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(reduxActions, dispatch);
};

export default connect(
    null,
    mapDispatchToProps
)(Message)